import { useLayoutEffect, useRef, useState } from "react";
import { Box, Tooltip, Typography } from "@mui/material";

const FittedMachineText = ({ children, variant, flex = 1, alignItems = "center" }) => {
    const containerRef = useRef(null);
    const measurementRef = useRef(null);
    const [fontSize, setFontSize] = useState(undefined);

    useLayoutEffect(() => {
        const container = containerRef.current;
        const measurement = measurementRef.current;
        let disposed = false;

        const fit = () => {
            if (disposed || !container.clientWidth || !container.clientHeight) return;

            const preferredSize = parseFloat(window.getComputedStyle(measurement).fontSize);
            const textWidth = measurement.getBoundingClientRect().width;
            const minimumSize = 14;
            // Measure an unconstrained copy so ellipsis and flex sizing cannot
            // conceal the full text width. Leave a pixel for rounding.
            const widthSize = textWidth > 0
                ? preferredSize * Math.max(0, container.clientWidth - 1) / textWidth
                : preferredSize;
            setFontSize(Math.max(minimumSize, Math.min(preferredSize, widthSize, container.clientHeight / 1.15)));
        };

        fit();
        const observer = new ResizeObserver(fit);
        observer.observe(container);
        document.fonts?.ready.then(fit);

        return () => {
            disposed = true;
            observer.disconnect();
        };
    }, [children, variant]);

    return (
        <Box ref={containerRef} sx={{ flex, minWidth: 0, minHeight: 0, width: "100%", display: "flex", alignItems, position: "relative", overflow: "hidden" }}>
            <Typography
                ref={measurementRef}
                component="span"
                variant={variant}
                aria-hidden="true"
                sx={{ position: "absolute", visibility: "hidden", width: "max-content", whiteSpace: "nowrap", lineHeight: 1.15, pointerEvents: "none" }}
            >
                {children}
            </Typography>
            <Tooltip title={children || ""}>
                <Typography
                    variant={variant}
                    noWrap
                    sx={{ width: "100%", minWidth: 0, textAlign: "center", lineHeight: 1.15, fontSize }}
                >
                    {children}
                </Typography>
            </Tooltip>
        </Box>
    );
};

export default FittedMachineText;
